import React from 'react';
import PropTypes from 'prop-types';
// CSS
import './CardList.css';

// #region COMPONENT
/**
 * @function CardList
 * @returns A CardList component
 */
const CardList = props => {
  const { children, justifyContent = 'center' } = props;
  return (
    <div className="CardList-Container" style={{ justifyContent }}>
      {children}
    </div>
  );
};
// #endregion

// #region PROPERTIES
/**
 * @param {React.ReactNode} children The child nodes to be rendered inside the CardList
 * @param {string} justifyContent The CSS justify-content property for the container
 */
CardList.propTypes = {
  children: PropTypes.node.isRequired,
  justifyContent: PropTypes.string,
};
// #endregion

export { CardList };
